











































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { queryDlDm, editDlDm, queryBu } from '@/api/systemProjectMember';
import moment from 'moment';
import store from '@/store';
import { hasPermission } from '@/utils/utils';
import selectMember from '@/components/project/selectMember.vue';
import { getVoteList, getDetail } from '@/api/project';

@Component({
  components: { selectMember },
  name: 'projectMember'
})
class projectMember extends Vue {
  page: number = 1;
  pageSize: number = 10;
  total: number = 0;
  keyword: string = '';
  filterOption: any = {
    searchDl: 0,
    searchDm: 0,
    searchDd: 0,
    searchBu: 0
  };
  companyList: any[] = [];
  tableList: any[] = [];
  visible: boolean = false;
  editInfo: any = {
    dl: [],
    dms: [],
    ddl: [],
    bu: '',
    vote: ''
  };
  hasBU: boolean = false;
  projectId: string = '';
  voteSelectList: any[] = [];
  suggestMember: any = {
    dls: [],
    dms: [],
    ddLs: []
  };
  // hasDL: boolean = false;
  // hasDDL: boolean = false;
  columns: any[] = [
    {
      title: '项目名称',
      dataIndex: 'companyName',
      key: 'companyName'
    },
    {
      title: '交易类型',
      dataIndex: 'dealType',
      key: 'dealType'
    },
    {
      title: '本轮交易轮次',
      dataIndex: 'roundName',
      key: 'roundName'
    },
    {
      title: '财务交割日期',
      dataIndex: 'deliveryDateText',
      key: 'deliveryDateText'
    },
    {
      title: '本轮DL',
      dataIndex: 'dlText',
      key: 'dlText'
    },
    {
      title: '本轮DM',
      dataIndex: 'dmText',
      key: 'dmText'
    },
    {
      title: '本轮DD Leader',
      dataIndex: 'ddlText',
      key: 'ddlText'
    },
    {
      title: '本轮所属BU',
      dataIndex: 'bu',
      key: 'bu'
    },
    {
      title: '关联vote',
      key: 'vote',
      scopedSlots: { customRender: 'vote' }
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  buOptions: any[] = ['Seed','Venture','Growth','总部'];

  created() {
    this.getList();
  }

  @Watch('filterOption', { deep: true })
  watchFilterOption() {
    this.page = 1;
    this.getList();
  }

  get suggestMemberFilter() {
    return {
      dls: this.suggestMember.dls.filter(_ => !this.editInfo.dl.find(e => e.id === _.id)),
      dms: this.suggestMember.dms.filter(_ => !this.editInfo.dms.find(e => e.id === _.id)),
      ddLs: this.suggestMember.ddLs.filter(_ => !this.editInfo.ddl.find(e => e.id === _.id))
    };
  }

  toProjectDetail(id: string) {
    window.open(`/project/detail?id=${id}&vote=1`);
  }

  async getList() {
    try {
      let res = await queryDlDm({
        page: this.page,
        pageSize: this.pageSize,
        searchName: this.keyword,
        ...this.filterOption
      });
      if (res.code === 200) {
        this.companyList = res.data.list || [];
        this.total = res.data.total;
        this.setTable();
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getVoteList() {
    try {
      let res = await getVoteList({ companyId: this.projectId });
      this.voteSelectList = res.data;
    } catch (e) {
      this.$message.error(e);
    }
  }

  async getProjectMember() {
    try {
      let res = await getDetail(this.projectId);
      if (res.code === 200) {
        let { member = {} } = res.data;
        this.suggestMember = member;
      }
    } catch (error) {
      console.log(error);
    }
  }

  setTable() {
    let list = this.companyList;
    let tableList = [];
    let companyRowList: any[] = []; //
    let calculatedTotal = 0;
    list.forEach(company => {
      let { deals } = company;
      deals.forEach(_ => {
        _.companyName = company.companyName;
        _.companyId = company.companyId;
        _.deliveryDateText = moment.unix(_.deliveryDate).format('YYYY.MM.DD');
        _.dlText = _.dl ? _.dl.name : '';
        _.ddlText = _.ddl ? _.ddl.name : '';
        _.dmText = _.dms.map(_ => _.name).join('、');
      });
      tableList = tableList.concat(deals);
      companyRowList.push({
        rowIndex: calculatedTotal,
        rowSpan: deals.length
      });
      calculatedTotal += deals.length;
    });
    this.tableList = tableList;
    this.setTableMerge(companyRowList);
  }

  setTableMerge(companyRowList) {
    this.columns[0] = {
      ...this.columns[0],
      customRender: (value, row, index) => {
        let companyRow = companyRowList.find(_ => _.rowIndex === index);
        if (companyRow) {
          return {
            children: value,
            attrs: { rowSpan: companyRow.rowSpan }
          };
        } else {
          return {
            attrs: { rowSpan: 0 }
          };
        }
      }
    };
  }

  handleSearch() {
    this.page = 1;
    this.getList();
  }

  edit(row) {
    this.visible = true;
    let { dl, dms, ddl, bu, companyId, voteId } = row;
    if (dl) {
      dl.nickname = dl.name;
    }
    this.projectId = companyId;
    this.getVoteList();
    this.getProjectMember();

    dms.forEach(_ => (_.nickname = _.name));
    if (ddl) {
      ddl.nickname = ddl.name;
    }
    this.editInfo = {
      ...row,
      dl: dl ? [dl] : [],
      dms: [...dms],
      ddl: ddl ? [ddl] : [],
      bu: bu ? bu : '',
      vote: voteId ? voteId : ''
    };
    // 如果BU有值，就不用再去查了
    this.hasBU = !!bu;
    this.queryBu();
  }

  chosePerson(type, val) {
    if (type === 'dl') {
      this.editInfo = {
        ...this.editInfo,
        dl: val
      };
      //如果没有BU，且之前没有DL
      this.queryBu();
    } else if (type === 'ddl') {
      this.editInfo = {
        ...this.editInfo,
        ddl: val
      };
      //如果没有BU，且之前没有DDL
      this.queryBu();
    } else {
      this.editInfo = {
        ...this.editInfo,
        dms: val
      };
    }
  }
  delPerson(type, val) {
    let { dl, dms, ddl } = this.editInfo;
    if (type === 'dl') {
      this.editInfo = {
        ...this.editInfo,
        dl: dl.filter(_ => _.id !== val.id)
      };
      this.queryBu();
    } else if (type === 'ddl') {
      this.editInfo = {
        ...this.editInfo,
        ddl: ddl.filter(_ => _.id !== val.id)
      };
      this.queryBu();
    } else {
      this.editInfo = {
        ...this.editInfo,
        dms: dms.filter(_ => _.id !== val.id)
      };
    }
  }

  addSuggest(type, val) {
    let { dl, dms, ddl } = this.editInfo;
    if (type === 'dl') {
      this.editInfo = {
        ...this.editInfo,
        dl: [val]
      };
      this.queryBu();
    } else if (type === 'ddl') {
      this.editInfo = {
        ...this.editInfo,
        ddl: [val]
      };
      this.queryBu();
    } else {
      this.editInfo = {
        ...this.editInfo,
        dms: [...dms, val]
      };
    }
  }

  async handleOk() {
    let { dl, dms, id, ddl, bu, vote } = this.editInfo;
    try {
      let res = await editDlDm({
        id,
        dl: dl.map(_ => _.id).join(','),
        dms: dms.map(_ => _.id).join(','),
        ddl: ddl.map(_ => _.id).join(','),
        bu,
        vote
      });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.handleCancel();
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleCancel() {
    this.editInfo = {
      dl: [],
      dms: [],
      ddl: [],
      bu: ''
    };
    this.visible = false;
  }

  onChange(page, pageSize) {
    this.page = page;
    this.getList();
  }

  async queryBu() {
    // 根据当前的editInfo的dl和ddl，查询BU
    try {
      if (!this.hasBU) {
        let { dl, ddl } = this.editInfo;
        if (dl.length || ddl.length) {
          let userId = ddl.length ? ddl[0].id : dl[0].id;
          let res = await queryBu({
            userId
          });
          if (res.code === 200) {
            this.editInfo = {
              ...this.editInfo,
              bu: res.data
            };
          }
        } else {
          this.editInfo = {
            ...this.editInfo,
            bu: ''
          };
        }
      }
    } catch (error) {}
  }
}
export default projectMember;
